import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Middle_Ages_-_Crusades.png';

function HistoryPageCrusades() {
  return (
    <TopicPage
      topicKey="Crusades"
      title="History: The Crusades"
      backgroundImage={bg}
      startRoute="/History-Crusades-Go"
      scrollLabels={[
        "Causes of the Crusades",
        "Major Campaigns",
        "Consequences",
      ]}
                    backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageCrusades;   